import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import styled from "styled-components";
import clientData from "../../Data/clientData";

const ClientArea = () => {
  const [clients, setClients] = useState([]);

  useEffect(() => {
    setClients(clientData);
  }, []);

  // Slider settings
  const settings = {
    dots: false,
    arrows: false,
    infinite: true,
    speed: 1000,
    autoplay: true,
    autoplaySpeed: 2000,
    slidesToShow: 8, // Display 8 items at a time
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 6, // Display 6 items on medium screens
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3, // Display 3 items on smaller screens
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2, // Display 2 items on very small screens
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <div className="overflow-hidden client-area-2">
      <Wrapper>
        <div className="container-fluid">
          <div className="row justify-content-center">
            <div className="col-xl-9 col-lg-10">
              <div className="title-area text-center">
                <span className="sub-title6 justify-content-center">
                  <span className="shape left">
                    <span className="dots"></span>
                  </span>
                  clients
                  <span className="shape right">
                    <span className="dots"></span>
                  </span>
                </span>
                <h2 className="sec-title">Our Trusted Clients</h2>
              </div>
            </div>
          </div>

          <Slider {...settings} className="row th-carousel">
            {/* Loop through the client array to render each item */}
            {clients.map((client) => (
              <div key={client.id} className="col-lg-auto text-center">
                <div className="client-thumb">
                  <img src={client.src} alt={client.alt} />
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </Wrapper>
    </div>
  );
};

const Wrapper = styled.section`
  .slick-arrow {
    display: none !important;
  }
`;

export default ClientArea;
